import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import * as hotjarTracking from '@hotjar/webapp/tracking/tools/hotjar';
import { extractAccountGroupingProps } from '@hotjar/webapp/tracking/utils';

import type { OwnedAccount, SiteAccount, Account } from '@hotjar/account';

interface Verify3DSChallengeProps {
  amountCharged: string;
  eligibleFor3DS: boolean;
  passed3DS: boolean;
  threeDSecureVersion: string;
  account: Account | SiteAccount | OwnedAccount;
}

/**
 * The result of the 3DS bank challenge attempt.
 * If eligibleFor3DS is false, the transaction was not challenged.
 * If passed3DS is true, the challenge was successful. This does not mean a 3DS challenge was
 * shown - banks can waive transactions through without a challenge.
 * @param {string} amountCharged The amount charged
 * @param {boolean} eligibleFor3DS Transaction is being passed through 3DS
 * @param {boolean} passed3DS Transaction successfully passed 3DS
 * @param {string} threeDSecureVersion Transaction successfully passed 3DS
 */
export function verify3DSChallenge({
  amountCharged,
  eligibleFor3DS,
  passed3DS,
  threeDSecureVersion,
  account,
}: Verify3DSChallengeProps): void {
  const trackingKey = '3DS Challenge Processed';

  const data = {
    ...extractAccountGroupingProps(account),
    amount: parseFloat(amountCharged),
    eligible_for_3ds: eligibleFor3DS,
    passed_3ds: passed3DS,
    version_of_3ds: threeDSecureVersion,
  };

  let trackingTagResult;
  if (!eligibleFor3DS) {
    trackingTagResult = 'not required';
  } else if (eligibleFor3DS && passed3DS) {
    trackingTagResult = 'required and authenticated';
  } else if (eligibleFor3DS && !passed3DS) {
    trackingTagResult = 'required and not authenticated';
  }

  Segment.track(trackingKey, data);
  hotjarTracking.tagRecording(`${trackingKey} - ${trackingTagResult}`);
}
